import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/authentication/auth.service';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { NgForm } from '@angular/forms';
import { AlertService } from '../../services/alert.service';
import { ConfigService } from '../../services/config/config.service';
import { Database } from '../../services/config/database';
import { TranslateService } from '@ngx-translate/core';

@Component({
   templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  invalidCredentialMsg: string;
  dbs: Database[] = [new Database("TEST")];
  language: string = "en";

  constructor(
      private authService: AuthService,
      private router: Router,
      private alertService: AlertService,
      private configService: ConfigService,
      private translate: TranslateService,
      private _formBuilder: FormBuilder) {
  }

  ngOnInit() {
    // reset login status
    this.authService.logoutUser(false);
    this.configService.getDbs().subscribe(
      dbs => {
        this.dbs = dbs;
      }
    );

    this.loginForm = this._formBuilder.group({
      username: [this.authService.getLoginInfo() === null ? null : this.authService.getLoginInfo().Username, Validators.required],
      password: [null, Validators.required],
      database: [this.authService.getLoginInfo() === null ? null : this.authService.getLoginInfo().Database, Validators.required],
    });

    let settings = JSON.parse(localStorage.getItem('webSecretariatSettings'));
    this.language = settings.language;
    this.translate.use(this.language);
  }

  login() {
    this.loading = true;
    this.authService.isUserAuthenticated(this.loginForm.value.username, this.loginForm.value.password, this.loginForm.value.database).subscribe(
      authenticated => {
       if (authenticated) {
        let url =  this.authService.getRedirectUrl();
        this.router.navigate([ url ]);
       } else {
        this.invalidCredentialMsg = 'Impossible to save login informations';
        this.loading = false;
        this.alertService.error('Impossible de sauvegarder les informations de login. Veuillez réessayer!');
       }
      },
      error => {
        console.log(`login() error : ${error.status} ${JSON.stringify(error.error)}`);
        if (error.status == 403) {
          this.invalidCredentialMsg = 'Invalid Credentials. Try again.';
          this.loading = false;
          this.alertService.error('Informations de login incorrectes. Veuillez réessayer!');
        } else {
          this.alertService.error('Erreur de connexion au service rest!');
          this.loading = false;
        }
      }
    );
  }

  useLanguage(language: string) {
    this.language = language;
    this.translate.use(language);
    let settings = JSON.parse(localStorage.getItem('webSecretariatSettings'));
    settings.language = language;
    localStorage.setItem( 'webSecretariatSettings', JSON.stringify(settings) );
  }
}
